import React, { useEffect, useState } from 'react';
import MilkSvg from '../../../assets/milk.svg';
import RollSvg from '../../../assets/roll.svg';
import MangoSvg from '../../../assets/mango.svg';
import { fruitsResumeData } from '../constants';
import { useAppContext } from '../../../context';

interface ICandidateIcon {
	type: 'milk' | 'roll' | 'mango';
	isVoted: boolean;
	isAccepted: boolean;
}

export const CandidateIcon: React.FC<ICandidateIcon> = ({ type, isVoted, isAccepted }) => {
	const [svgContent, setSvgContent] = useState<string>('');

	const iconSrc = {
		milk: MilkSvg,
		roll: RollSvg,
		mango: MangoSvg
	}[type];

	useEffect(() => {
		fetch(iconSrc)
			.then(res => res.text())
			.then(text => {
				const color = isVoted
					? (isAccepted ? '#C6E7C5' : '#FB9BB4')
					: '#EFEFEF';
				const newSvg = text.replace(/<path/g, `<path fill="${color}"`);
				setSvgContent(newSvg);
			});
	}, [isVoted, isAccepted, iconSrc]);

	return (
		<div
			className="w-[57px] h-[64px]"
			dangerouslySetInnerHTML={{ __html: svgContent }}
		/>
	);
}
interface ICandidatesList {
	stage: number;
}

export const CandidatesList: React.FC<ICandidatesList> = ({ stage }) => {
	const { fruitType } = useAppContext();
	const { forms } = fruitsResumeData[fruitType]
	return (
		<div className="flex mt-4 gap-4 justify-between w-full">
			{Array.from({ length: 5 }, (_, index) => (
				<CandidateIcon
					key={index}
					type={fruitType}
					isVoted={index < stage - 1}
					isAccepted={index < stage ? forms[index].isAcceptCorret : false}
				/>
			))}
		</div>
	);
};
